export const permissions = {
    canViewVehicles: state => {
        return state.permissions.includes('vehicle_view');
    },
    canEditVehicles: state => {
        return state.permissions.includes('vehicle_edit');
    },
    canDeleteVehicles: state => {
        return state.permissions.includes('vehicle_delete');
    },
    canViewClients: state => {
        return state.permissions.includes('client_view');
    },
    canEditClients: state => {
        return state.permissions.includes('client_edit');
    },
    canDeleteClients: state => {
        return state.permissions.includes('client_delete');
    },
    canViewContracts: state => {
        return state.permissions.includes('contract_view');
    },
    canEditContracts: state => {
        return state.permissions.includes('contract_edit');
    },
    canDeleteContracts: state => {
        return state.permissions.includes('contract_delete');
    },
    canViewOffers: state => {
        return state.permissions.includes('offer_view');
    },
    canEditOffers: state => {
        return state.permissions.includes('offer_edit');
    },
    canDeleteOffers: state => {
        return state.permissions.includes('offer_delete');
    },
    canViewUsers: state => {
        return state.permissions.includes('user_view');
    },
    canEditUsers: state => {
        return state.permissions.includes('user_edit');
    },
    canDeleteUsers: state => {
        return state.permissions.includes('user_delete');
    },
    canViewRoles: state => {
        return state.permissions.includes('role_view');
    },
    canEditRoles: state => {
        return state.permissions.includes('role_edit');
    },
    canDeleteRoles: state => {
        return state.permissions.includes('role_delete');
    },
    canViewSettings: state => {
        return state.permissions.includes('settings_view');
    },
    canEditSettings: state => {
        return state.permissions.includes('settings_edit');
    },
    canDeleteSettings: state => {
        return state.permissions.includes('settings_delete');
    },
    canEditPrices: state => {
        return state.permissions.includes('prices_edit');
    }
};
